import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_TASK_MANAGER } from '../redux/constants/rolesConstants';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import TasksHeader from '../components/tasks/TasksHeader';
import TasksList from '../components/tasks/TasksList';
import TasksPagination from '../components/tasks/TasksPagination';

const Tasks = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_TASK_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Послуги'} />
        </PageTitleContainer>
        <Container>
          <TasksHeader readOnly={readOnly} />
          <TasksList readOnly={readOnly} />
          <TasksPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Tasks;
